import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Popover, OverlayTrigger, Button } from "react-bootstrap";
import { EmailLogsList } from "../../redux/actions/userAction/userAction";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import Alert from "../Common/Alert";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import FilterComponent from "./FilterComponent";
import * as constantMessages from "../../constants/constatntMessages";
import ViewEmailLogModal from "./ViewEmailLogModal";
import ActivityDropDown from "./ActivityDropDown";
import BackButton from "../Common/Backbutton";
const regularExpression = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;

function EmailActivitylogs() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  const actionData = useSelector((state) => state.action);
  const accessToken = localStorage.getItem("accessToken");
  const [filter, setFilter] = useState(false);
  const emailLogsList = useSelector((state) => state.emailLog) || [];

  const employeeData = useSelector((state) => state.user);

  const totalCount = emailLogsList.totalCount;

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [screenSize, setScreenSize] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call on initial render if needed
    handleResize();

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const emailData = Array.isArray(emailLogsList?.EmailLogsList)
    ? emailLogsList.EmailLogsList
    : [];

  const [searchData, setSearchData] = useState({
    searchKey: "",
    page: 1,
    limit: 10,
    order: -1,
    filterData: {},
  });

  const [selectedEmail, setSelectedEmail] = useState(null);
  const [isViewEmailModalOpen, setIsViewEmailModalOpen] = useState(false);

  useEffect(() => {
    document.title = "Email Logs: MinutesVault";

    const payload = {
      page: searchData.page,
      order: searchData.order,
      limit: searchData.limit,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
      organizationId: employeeData?.userData?.organizationId,
    };

    if (searchData.searchKey.trim()) {
      payload.searchKey = searchData.searchKey;
      const errors = {};
      if (!regularExpression.test(searchData.searchKey)) {
        errors.searchKey = constantMessages.titleRegexError;
        setErrors(errors);
        return;
      } else {
        setErrors({});
      }
    } else {
      setErrors({});
    }
    callEmailLogsList(payload);
  }, [
    searchData.searchKey,
    searchData.order,
    searchData.page,
    searchData.limit,
    searchData.filterData,
    employeeData?.userData?.organizationId,
  ]);

  const callEmailLogsList = async (payload) => {
    setLoading(true);
    await dispatch(EmailLogsList(payload, accessToken));
    setLoading(false);
  };

  useEffect(() => {
    if (searchData.searchKey !== "") {
      const payload = {
        page: 1,
        order: searchData.order,
        limit: searchData.limit,
        toDate: searchData.filterData?.toDate,
        fromDate: searchData.filterData?.fromDate,
        organizationId: employeeData?.userData?.organizationId,
      };

      if (searchData.searchKey !== "") {
        payload["searchKey"] = searchData.searchKey;
        setSearchData({
          ...searchData,
          page: 1,
        });
        payload.page = 1;
      }
      if (searchData.filterData.page === 1) {
        payload["searchKey"] = searchData.searchKey;
        setSearchData({
          ...searchData,
          page: 1,
        });
        payload.page = 1;
      }

      if (searchData.searchKey.trim()) {
        const errors = {};
        if (!regularExpression.test(searchData.searchKey)) {
          errors.searchKey = constantMessages.titleRegexError;
          setErrors(errors);
        } else {
          setErrors({});
          callEmailLogsList(payload);
        }
      } else {
        setErrors({});
        callEmailLogsList(payload);
      }
    } else {
      setSearchData({
        ...searchData,
        page: 1,
      });
    }
  }, [searchData.searchKey]);

  const filterData = (data) => {
    setSearchData((prev) => ({
      ...prev,
      filterData: data,
      page: 1,
    }));
  };

  const handlePageChange = (event, value) => {
    setSearchData((prev) => ({
      ...prev,
      page: value,
    }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setSearchData((prev) => ({
      ...prev,
      [name]: value,
      page: 1,
    }));
    const newPayload = {
      page: 1,
      order: searchData.order,
      limit: searchData.limit,
      toDate: searchData.filterData?.toDate,
      fromDate: searchData.filterData?.fromDate,
    };

    if (value.trim() !== "") {
      newPayload["searchKey"] = value;
    }

    if (value.trim() === "") {
      callEmailLogsList(newPayload);
    }
  };

  const totalOption =
    totalCount && totalCount % 5 === 0
      ? Math.round(emailLogsList.totalCount / 5)
      : totalCount && totalCount % 5 !== 0
        ? Math.round(totalCount / 5 + 0.5)
        : 0;
  const checkTotalPage =
    totalCount % searchData.limit === 0
      ? Math.round(totalCount / searchData.limit)
      : Math.round(totalCount / searchData.limit + 0.5);
  const totalPage = totalCount ? checkTotalPage : 0;

  const totalPageArray = Array(totalPage).fill();

  let modifiedArray = [];
  totalPageArray.map((item, index) => {
    if (
      index === searchData.page - 1 ||
      (index <= searchData.page + 3 && index >= searchData.page)
    ) {
      modifiedArray.push(index);
    }
    return item;
  });

  const fromDataCount =
    emailLogsList.length === 0
      ? 0
      : (searchData.page - 1) * searchData.limit + 1;
  const toDataCount =
    (searchData.page - 1) * searchData.limit + emailData.length;
console.log("item",emailLogsList)
  const renderPopover = (message) => (
    <Popover id="popover-message">
      <Popover.Body>{message}</Popover.Body>
    </Popover>
  );

  return (
    <>
      <div className="main-content">
        <div className="meeting-header-text line-height-h4 d-flex align-items-center justify-content-between">
          <h4>Email Logs</h4>

          <BackButton show={camefromPreviousPage} />
        </div>
        <FilterComponent
          setfilter={setFilter}
          filterData={filterData}
          initData={searchData.filterData}
          filter={filter}
        />
        <div className="mt-2 table-box responsive-table">
          <div className="d-flex align-items-center justify-content-between resp-flex-column mb-2">
            <div className="left-tbl-text">
              {totalCount > 0 ? (
                <p>
                  Showing {fromDataCount} to {toDataCount} of {totalCount}{" "}
                  entries
                </p>
              ) : null}
            </div>

            <div className="meeting-f-search width-auto">
              <div className="search-box d-flex align-items-center position-relative">
                <input
                  type="search"
                  placeholder="Search By Email Type / Email  To / Subject"
                  name="searchKey"
                  onChange={handleChange}
                  value={searchData.searchKey}
                  autoComplete="off"
                />

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#4F2CC8"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>

                {errors?.searchKey && (
                  <span className="error-message position-absolute-error-msg">
                    {errors?.searchKey}
                  </span>
                )}
              </div>

              <button
                className="btn add-btn Mom-btn d-flex align-items-center justify-content-center filter-height"
                id="open-form-btn"
                onClick={(e) => setFilter(true)}
              >
                <p>Filter</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-funnel filter-svg"
                  viewBox="0 0 16 16"
                >
                  <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
                </svg>
              </button>
            </div>
          </div>

          {loading ? (
            <div
              className="meeting-page"
              style={{ textAlign: "center", paddingTop: 20 }}
            >
              <Loader />
            </div>
          ) : !emailLogsList?.loading && emailLogsList.isSuccess ? (
            <div className="table-responsive">
              <table className="mt-4 table table-bordered table-striped">
                <thead>
                  <tr>
                    <th  style={{ textAlign: "center" }}>Sl.No</th>
                    <th>Date & Time</th>
                    <th>Email Type</th>
                    <th>Email From</th>
                    <th>Email To</th>
                    <th>Subject</th>
                    <th className="action-col" scope="col">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {emailData.map((item, index) => {
                    return (
                      <tr key={item._id}>
                        <td data-label="Sl No." className="blue-bold-text">
                          {(searchData.page - 1) * searchData.limit + index + 1}

                          {screenSize <= 768 ? (
                            <div className="d-inline-block menu-dropdown custom-dropdown inner1-drp">
                              <ActivityDropDown action={item} />
                            </div>
                          ) : null}
                        </td>
                        <td
                          data-label="Created At Date & Time"
                          className="meeting-td-width-slno"
                        >
                          {item?.createdAt.formattedDate}
                          <p className="detail-date-time">
                            {" "}
                           {item?.createdAt.formattedTime}
                          </p>
                        </td>
                        <td
                          data-label="Email Type"
                          onClick={() => {
                            setSelectedEmail(item);
                            setIsViewEmailModalOpen(true);
                          }}
                        >
                          <span className="clickable">{item.emailType}</span>
                        </td>
                        <td data-label="Email From">
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={renderPopover(item.emailFrom)}
                          >
                            <span className="message-preview global-email-width">
                              {(() => {
                                const emailMatch =
                                  item.emailFrom.match(/<([^>]+)>/);
                                const emailOnly = emailMatch
                                  ? emailMatch[1]
                                  : item.emailFrom;
                                return emailOnly.length > 30
                                  ? `${emailOnly.slice(0, 30)}...`
                                  : emailOnly;
                              })()}
                            </span>
                          </OverlayTrigger>
                        </td>

                        <td data-label="Email To">
                          <span className="global-email-width">
                            {item.emailTo}
                          </span>
                        </td>
                        <td data-label="Subject">
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="top"
                            overlay={renderPopover(item.subject)}
                          >
                            <span className="message-preview">
                              {item.subject.length > 30
                                ? `${item.subject.slice(0, 30)}...`
                                : item.subject}
                            </span>
                          </OverlayTrigger>
                        </td>

                        {screenSize <= 768 ? null : (
                          <td
                            data-label="Action"
                            className="text-align-center"
                          >
                            <div className="d-inline-block menu-dropdown custom-dropdown">
                              <ActivityDropDown action={item} />
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="no-data-img mt-3">
              <Alert
              
                status="info"
                message="No data available."
                timeoutSeconds={0}
              />
              <NoDataFound dataType="meeting" />
              {(Object.keys(searchData?.filterData || {}).length !== 0 ||
                searchData?.searchKey) && (
                <Button
                  className="mt-2"
                  variant="primary"
                  onClick={() =>
                    setSearchData({
                      ...searchData,
                      searchKey: "",
                      filterData: {},
                      page: 1,
                    })
                  }
                >
                  Clear
                </Button>
              )}
            </div>
          )}

          {emailData && emailData.length > 0 && totalCount > 1 && (
            <div className="tbl-bottom">
              <div className="left-tbl-bottom">
                {searchData.page !== 1 && (
                  <button
                    className="left-arrow"
                    onClick={() =>
                      setSearchData({
                        ...searchData,
                        page: searchData.page - 1,
                      })
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#fff"
                      className="bi bi-chevron-left"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                      />
                    </svg>
                  </button>
                )}

                <Stack spacing={2}>
                  <Pagination
                    count={totalPage}
                    page={searchData.page}
                    siblingCount={0}
                    boundaryCount={2}
                    onChange={handlePageChange}
                    hidePrevButton
                    hideNextButton
                    sx={{
                      "& .Mui-selected": {
                        backgroundColor: "#388d27 !important",
                        color: "#fff !important",
                      },
                    }}
                  />
                </Stack>

                {searchData.page !== totalPage && (
                  <button
                    className="right-arrow"
                    onClick={() =>
                      setSearchData({
                        ...searchData,
                        page: searchData.page + 1,
                      })
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#fff"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                      />
                    </svg>
                  </button>
                )}
              </div>

              <div className="right-tbl-bottom">
                <p>Rows Per Page</p>
                <select
                  className="no-opt-box"
                  name="limit"
                  onChange={(e) =>
                    setSearchData({
                      ...searchData,
                      page: 1,
                      limit: e.target.value,
                    })
                  }
                  value={searchData.limit}
                >
                  {totalOption &&
                    Array(totalOption)
                      .fill()
                      .map((_, option) => (
                        <option key={option} value={(option + 1) * 5}>
                          {(option + 1) * 5}
                        </option>
                      ))}
                </select>
              </div>
            </div>
          )}
        </div>
        <ViewEmailLogModal
          setIsModalOpen={setIsViewEmailModalOpen}
          isModalOpen={isViewEmailModalOpen}
          emailData={selectedEmail}
        />
      </div>
    </>
  );
}

export default EmailActivitylogs;
